
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.53","height":"22.215"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.944 19.958v1.441a.719.719 0 00.719.719h11.503a.719.719 0 00.719-.719v-1.438a2.159 2.159 0 00-2.159-2.162H5.1a2.159 2.159 0 00-2.156 2.159zm1.438.719v-.719a.72.72 0 01.719-.719h8.625a.72.72 0 01.719.719v.719H4.382zM23.274 3.277l-.629-1.645a2.155 2.155 0 00-3.382-.9L17.38 2.276l-7.277 2.78L9.394 3.2l.071-.715A2.156 2.156 0 006.549.258L1.494 2.189a2.156 2.156 0 00-.688 3.6l.53.486.709 1.856.513 1.343h0l.513 1.343h0l.513 1.343.709 1.856-.071.715a2.156 2.156 0 002.916 2.227l5.055-1.931a2.157 2.157 0 00.688-3.6l-.53-.486-.708-1.856 7.276-2.779 2.433-.105a2.156 2.156 0 001.922-2.924zM2.106 5.035l-.327-.3a.719.719 0 01.229-1.2l5.055-1.931a.719.719 0 01.972.742l-.044.442zm.77 1.245l5.372-2.052 2.565 6.715-5.372 2.052zm9.034 6.205a.719.719 0 01-.229 1.2l-5.055 1.931a.719.719 0 01-.972-.742l.044-.442 5.884-2.247zm-.78-4.744l-.511-1.34 4.029-1.539.513 1.343zm5.372-2.052l-.513-1.343 1.343-.513.513 1.343zm4.789-.927l-2.032.088-.656-1.718 1.573-1.289a.718.718 0 011.127.3l.629 1.645a.718.718 0 01-.641.977z","fill":"#fff","stroke":"#fff","stroke-width":".2"}})])
          )
        }
      }
    